/**
 * Card.
 *
 * White surface, light border, optional title row. Carries a subtle drop
 * shadow (Patch 5+) so cards lift slightly off the canvas — without it the
 * grid of cards on dashboards read as a flat sheet of grey lines. Overlays
 * (Modal, Drawer) still own the heavier `shadow-overlay` for clear
 * hierarchy.
 */
import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  actions?: ReactNode;
  bodyClassName?: string;
}

export function Card({ title, actions, className, bodyClassName, children, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-md border border-border-default bg-surface shadow-card',
        className,
      )}
      {...rest}
    >
      {title || actions ? (
        <div className="flex items-center justify-between border-b border-border-default px-4 py-3">
          {title ? <h3 className="text-base font-semibold text-primary">{title}</h3> : <span />}
          {actions}
        </div>
      ) : null}
      <div className={cn('p-4', bodyClassName)}>{children}</div>
    </div>
  );
}
